/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./index.scss";

import { duration } from "utils";
// ui
import { Row, Col } from "antd";
// animation
import { Fade, Zoom } from "react-reveal";

import SentienImage from "../../../assets/icons/sentient.svg";
import DotsImage from "../../../assets/icons/line-dots.svg";
import ProductImage from "assets/images/cerebral.png";
import Product1Image from "assets/icons/sentient-product.svg";
// import TwoRightIcon from "assets/icons/two-right.svg";

const Sentient = (props) => {
  return (
    <div className="sentient" ref={props.sentientRef}>
      <div className="customContainer">
        <Zoom bottom duration={duration}>
          <div className="viewDots">
            <img src={DotsImage} alt="" />
          </div>
        </Zoom>

        <Fade bottom duration={duration}>
          <div className="viewIconSentient">
            <img src={SentienImage} alt="" />
          </div>
        </Fade>

        {/* <Fade bottom duration={duration}>
          <h2>Sentient (Precog V2)</h2>
          <h6>Increase the leverage without the risk</h6>
        </Fade> */}

        <div className="productItem">
          <Row gutter={40}>
            <Col lg={12} xs={24}>
              <Fade bottom duration={duration}>
                <div className="viewProduct">
                  <img alt="" src={Product1Image} />
                </div>
              </Fade>
            </Col>
            <Col lg={12} xs={24}>
              <Fade bottom duration={duration}>
                <div className="detailProduct">
                  <div>
                    <h4>Precog (Sentient v.2)</h4>
                    <p>
                      Phase 2 involves another market opportunity. At times, the
                      futures premium is so high that savvy investors with
                      access to capital or leverage can scale their profits
                      significantly while maintaining the same risk-less
                      component. Our advanced Sentient smart contract identifies
                      these market opportunities, and then calculates with the
                      available decentralized lendingmarkets to aggregate the
                      best rates. If the calculation is still net positive, then
                      Precog will borrow the capital using the collateral
                      participants hold inthe contract. It then executes the
                      same arbitrage trade – significantly boosting the dollar
                      value return.
                    </p>

                    {/* <a>
                      Learn more <img alt="" src={TwoRightIcon} />{" "}
                    </a> */}
                  </div>
                </div>
              </Fade>
            </Col>
          </Row>
        </div>

        <div className="productItem">
          <Row gutter={40}>
            <Col lg={12} xs={24}>
              <Fade bottom duration={duration}>
                <div className="viewProduct">
                  <img alt="" src={ProductImage} />
                </div>
              </Fade>
            </Col>
            <Col lg={12} xs={24}>
              <Fade bottom duration={duration}>
                <div className="detailProduct">
                  <div>
                    <h4>Cerebral</h4>
                    <p>
                      Cerebral aims to be the market's very first decentralized
                      futures and options marketplace, enabling users to bid and
                      sell options on almost any ERC20 token, and one day, any
                      chain outside ethe Ethereum network. On Cerebral, the
                      community defines, creates, and deploys the synthetic
                      assets. Using a decentralized order book, users are
                      incentivized to create order book depth by contributing to
                      pooled assets relative to supply demand flow, or the
                      meditation of a future expiry date. The users contribute
                      and earn revenues on those markets. Cerebral will have its
                      own token and Precog.finance holders will receive 50% as
                      an airdrop after its first 12 months of operation.
                    </p>

                    {/* <a>
                      Learn more <img alt="" src={TwoRightIcon} />{" "}
                    </a> */}
                  </div>
                </div>
              </Fade>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Sentient;
